import React, { useCallback, useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { getPropertiesByOwner } from 'services/libraries';

const VendorLibraries = ({onLibrarySelected, variant="standard", width=280, vendorId=null}) => {
  const [libraryList, setLibrayList] = useState([]);
  const [librarySelected, setLibraySelected] = useState('');

  const getVendorLibraries = useCallback(function(ownerId){
    getPropertiesByOwner({ownerId}).then(({response, error}) => {
      if(response){
        setLibrayList([...(response || [])]);
      } else {
        setLibrayList([]);
      }
    });
  },[]);

  useEffect(() => {
    if(vendorId){
      setLibraySelected('');
      getVendorLibraries(vendorId)
    }else{
      setLibrayList([]);
      setLibraySelected('');
    }
  }, [vendorId, getVendorLibraries]);

  useEffect(() => {
    if(typeof onLibrarySelected === 'function'){
      onLibrarySelected(librarySelected);
    }
  }, [librarySelected, onLibrarySelected]);

  return (
    <FormControl sx={{fontSize: 12}} fullWidth>
       <InputLabel size="small" id="library-select-label">Library</InputLabel>
      <Select 
        size="small"
        labelId="library-select-label"
        value={librarySelected}
        label="Library" 
        defaultValue=''
        variant={variant}
        onChange={(e) => setLibraySelected(e.target.value)}
        sx={{ padding: '2px 0 1px', fontSize: 14 }}
        // disable Underline
      >
        {libraryList.map((library, index) => <MenuItem key={index} value={library}>{library.name}</MenuItem>)}
      </Select>
    </FormControl>
  );
}
 
export default React.memo(VendorLibraries);
